var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5217 7.10887L17.4216 5.57914C17.2965 5.46203 17.148 5.36688 16.9526 5.27173L11.4734 2.38792C10.9888 2.13175 10.4885 2 10.0039 2C9.51148 2 9.01124 2.13175 8.52662 2.38792L7.02589 3.17841L14.5217 7.10887ZM9.99609 9.47301L13.318 7.73102L5.86126 3.79323L3.04739 5.27173C2.85979 5.36688 2.70347 5.46203 2.57841 5.57914L9.99609 9.47301ZM10.5745 18C10.6527 17.9854 10.723 17.9488 10.8012 17.9122L16.851 14.7356C17.6092 14.333 18 13.9158 18 12.8692V7.01372C18 6.83074 17.9844 6.67704 17.9453 6.53065L10.5745 10.4245V18ZM9.4255 18V10.4245L2.05471 6.53065C2.01563 6.67704 2 6.83074 2 7.01372V12.8692C2 13.9158 2.39082 14.333 3.149 14.7356L9.19883 17.9122C9.26917 17.9488 9.34734 17.9854 9.4255 18Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProduct);
export default __webpack_public_path__ + "static/media/icon-product.13a121507cb206ad9ddc4173402629f2.svg";
export { ForwardRef as ReactComponent };